import { AttendanceStatusEnum, PositionRoleEnum } from "@sinch/core/entities/serverEnums";
import type {
  AttendanceStatusEnum as AttendanceStatusEnumStrings,
  PositionRoleEnum as PositionRoleEnumStrings,
} from "@sinch/types/sinch.types";
import { any, flatten, pluck, propEq, sum } from "ramda";
import { DataPairProps } from "@sinch/views/ShiftTimeline/TimelinesContainer/components/HeaderIcons";
import { attendanceCount, pendingCount } from "@sinch/components/AttendanceCounter/AttendanceCounter";

export function getShiftStats(
  positions: {
    size: number;
    role: PositionRoleEnum | PositionRoleEnumStrings;
    attendances: {
      status?: AttendanceStatusEnum | AttendanceStatusEnumStrings | null;
    }[];
  }[]
) {
  const attendance = sum(
    pluck(
      "attendances",
      positions.filter((position) => position.role !== PositionRoleEnum.Standby)
    ).map(attendanceCount)
  );
  const attendanceSlots = sum(
    pluck(
      "size",
      positions.filter((position) => position.role !== PositionRoleEnum.Standby)
    )
  );
  const standby = sum(
    pluck(
      "attendances",
      positions.filter((position) => position.role === PositionRoleEnum.Standby)
    ).map(attendanceCount)
  );
  const standbySlots = sum(
    pluck(
      "size",
      positions.filter((position) => position.role === PositionRoleEnum.Standby)
    )
  );
  const attendancePending = pendingCount(flatten(pluck("attendances", positions)));

  const hidden: DataPairProps = {
    display: any(propEq("hidden", true))(positions as any),
    partial: any(propEq("hidden", false))(positions as any),
  };

  const locked: DataPairProps = {
    display: any(propEq("lockstatus", true))(positions as any),
    partial: any(propEq("lockstatus", false))(positions as any),
  };

  return {
    attendance,
    attendanceSlots,
    standby,
    standbySlots,
    attendancePending,
    hidden,
    locked,
  };
}
